export default __webpack_public_path__ + "static/Minipax-SemiBold-11147e6fc4650d5ef00c94075e0df0e8.woff2";